import { render, staticRenderFns } from "./TmDataMsg.vue?vue&type=template&id=4d7684a6&"
import script from "./TmDataMsg.vue?vue&type=script&lang=js&"
export * from "./TmDataMsg.vue?vue&type=script&lang=js&"
import style0 from "./TmDataMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports